// extracted by mini-css-extract-plugin
export default {"recos":"h2-z","productCardOverride":"i2-z","rowHasBadge":"j2-z"};